module.exports = __webpack_public_path__ + "images/93d83f659119f4960bb35b57c1974560.svg";